import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import catalog from "../data/catalog";
import WhatsAppIcon from "./WhatsAppIcon";

const wa = `https://wa.me/${catalog.WHATSAPP}?text=${encodeURIComponent(
  "Hi IndustrialPro, I need help with an industrial automation issue."
)}`;

export function CallBtn({ className = "", label = "Call Now", testId = "call-btn" }) {
  return (
    <a
      href={`tel:${catalog.PHONE_TEL}`}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 font-head font-bold uppercase tracking-wide bg-safety text-white px-6 h-12 rounded-full hover:bg-safety-600 transition-colors ${className}`}
    >
      <Phone className="h-4 w-4" /> {label}
    </a>
  );
}

export function WhatsAppBtn({ className = "", label = "WhatsApp", testId = "whatsapp-btn" }) {
  return (
    <a
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 font-head font-bold uppercase tracking-wide border-2 border-[#25D366] text-[#25D366] px-6 h-12 rounded-full hover:bg-[#25D366] hover:text-white transition-colors ${className}`}
    >
      <WhatsAppIcon className="h-4 w-4" /> {label}
    </a>
  );
}

export function QuoteBtn({ className = "", label = "Get a Quote", testId = "quote-btn" }) {
  return (
    <Link
      to="/request"
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 font-head font-bold uppercase tracking-wide bg-ink text-white px-6 h-12 rounded-full hover:bg-ink-light transition-colors ${className}`}
    >
      <FileText className="h-4 w-4" /> {label}
    </Link>
  );
}

export const WHATSAPP_URL = wa;
